/*
*###############################################################################
*Module Name                   : TransactionRemHED.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Thursday, October 14th 2021, 10:07:33 am      #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useState } from "react"
import { Row, Col, Button, Label, Alert } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import { Text } from "../../../framework/validators/TextValidation"
import RemarksDrawer from "./Support-Widgets/RemarksDrawer"


const TransactionRemHED = ({
    DataRow,
    blDiasableGrid,
    DisableDet,
    SetRemHedDataRow
}) => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    function RemoveRowBy(key) {
        //remove item using key
        //remove item by index using splice
        const items = [...DataRow];
        items.splice(key, 1);
        //set state to new array
        if (items.length == 0) {
            items.push({ id: 1, strRHED_REMARK: "" })
        }
        SetRemHedDataRow(items)
    }

    function handleRowChanges(newval, values, element, Key) {
        var DataRows = [...DataRow]
        var oldValue = values
        oldValue[element] = newval
        DataRows[Key] = oldValue
        SetRemHedDataRow(DataRows);
    }

    const AddRow = () => {
        var modifiedRowsRem = [...DataRow]
        modifiedRowsRem.push({ id: modifiedRowsRem.length + 1, strRHED_REMARK: "" })
        SetRemHedDataRow(modifiedRowsRem)
    }


    return (
        <React.Fragment>
            <Row className="mb-3">
                <Col sm={6} md={6}>
                    Header Remarks
                </Col>
                {/* <Col sm={6} md={6} className="text-end">
                    <Button
                        color="primary"
                        size="sm"
                        onClick={toggleDrawer}
                        className="me-2"
                    >
                        <i className="mdi mdi-format-list-bulleted me-1"></i>
                        View Remarks
                    </Button>
                </Col> */}
            </Row>
            <Row>
                <Col sm={12} md={12} className="mb-12-sm">
                    <table style={{ fontSize: "11px" }} id={"tblRemHed"}>
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th style={{ textAlign: "left" }}>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(DataRow || [{ id: 1 }]).map((formRow, key) => (
                                <TableRemRow
                                    FormRow={formRow}
                                    Key={key}
                                    RemoveRow={RemoveRowBy}
                                    DisableDet={DisableDet}
                                    handleRowChanges={handleRowChanges}
                                    AddRow={AddRow}
                                    DataRow={DataRow}
                                />
                            ))}
                        </tbody>
                    </table>
                </Col>
            </Row>
            <br />

            {/* <RemarksDrawer
                isOpen={drawerOpen}
                onClose={toggleDrawer}
                data={DataRow}
            /> */}
        </React.Fragment>
    );
}
export default TransactionRemHED

const TableRemRow = ({ FormRow, Key, RemoveRow, DisableDet, handleRowChanges, AddRow, DataRow }) => {

    const KeyPressEvt = (e) => {
        if (e.charCode == 13) {

            var emptyRow = DataRow.findIndex(x => x.strRHED_REMARK == "" || x.strRHED_REMARK == null)

            if (emptyRow == -1) {
                AddRow()
                setTimeout(() => {
                    document.getElementById("txtRemarksHed" + (Key + 1)).focus()
                }, 100)
            } else {
                document.getElementById("txtRemarksHed" + emptyRow).focus()
            }
        }
    }

    return (
        <tr key={FormRow.id}>
            <td style={{ width: "50px" }}>
                <Row className="mb-3" style={{ marginLeft: '2px' }}>
                    {Key + 1}
                </Row>

            </td>
            <td style={{ width: "400px" }}>
                <Row className="mb-3">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Remarks"
                            textType="text"
                            disabled={DisableDet}
                            textAlign="left"
                            id={"txtRemarksHed" + Key}
                            value={FormRow.strRHED_REMARK}
                            onChange={(e) => {
                                let remVal = Text(e.target, 100, true, true, "Any", true)
                                handleRowChanges(remVal, FormRow, "strRHED_REMARK", Key)
                            }}
                            onKeyPress={KeyPressEvt}
                        ></DPTextBoxforgrid>

                    </Col>

                </Row>

            </td>
            <td>
                <Row className="mb-3">
                    <Col md="1">
                        <Button
                            outline
                            disabled={DisableDet}
                            color="danger"
                            onClick={e => {
                                RemoveRow(Key)
                            }}
                            size="sm"
                        >
                            <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
                        </Button>
                    </Col>{" "}
                </Row>
            </td>
        </tr>
    )
}